//#region src/errors.ts
var SandboxUnavailableError = class SandboxUnavailableError extends Error {
	constructor(message, reason) {
		super(message);
		this.name = "SandboxUnavailableError";
		this.reason = reason;
		Error.captureStackTrace?.(this, SandboxUnavailableError);
	}
};
function isSandboxUnavailableError(error) {
	return error instanceof SandboxUnavailableError;
}
//#endregion
export { SandboxUnavailableError, isSandboxUnavailableError };

//# sourceMappingURL=errors.mjs.map